import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import DeviceManagementModals from '~/DeviceManagementModals';
import ChatbotEntryPoint from '~/features/chatbot/components/EntryPoint/ChatbotEntryPoint';
import ChatbotPopup from '~/features/chatbot/components/ChatbotPopup';
import ChatbotSidebar from '~/features/chatbot/components/ChatbotSidebar';
import { CHATBOT_PATH } from '~/features/base/constants/routes';

/**
 * Chatbot entry mode configuration.
 * - 'popup': clicking the entry point toggles a floating chat card (default — matches reference design)
 * - 'sidebar': clicking the entry point toggles a right-side panel
 * - 'full-page': clicking the entry point navigates to the /chatbot route
 *
 * Change this constant to switch between modes for A/B comparison.
 */
export const CHATBOT_MODE = 'popup';

export const ApplicationContentWrapper = ({ children }) => {
    const history = useHistory();
    const [isChatbotOpen, setIsChatbotOpen] = useState(false);
    const isLoggedIn = useSelector((state) => {
        const hasToken = Boolean(state.tokenHandling?.accessToken);
        const hasProfile = Boolean(state.login?.userProfile);
        const sessionExpired = state.login?.userSessionExpired;
        const userLoaded = state.ui?.errors?.userLoaded;
        return hasToken && hasProfile && !sessionExpired && userLoaded !== false;
    });

    const handleChatbotClick = () => {
        if (CHATBOT_MODE === 'full-page') {
            history.push(`/${CHATBOT_PATH}`);
        } else {
            setIsChatbotOpen((prev) => !prev);
        }
    };

    const handleChatbotClose = () => {
        setIsChatbotOpen(false);
    };

    return (
        // container-fluid fluid-large
        <React.Fragment id='devicemanagement devicemanagement-frame'>
            {/*<ReloadProgress period={20000}/>*/}
            <DeviceManagementModals/>
            <React.Fragment id='devicemanagement-frame-content'>
                {children}
            </React.Fragment>
            {isLoggedIn && (
                <>
                    <ChatbotEntryPoint onClick={handleChatbotClick} isActive={isChatbotOpen} />
                    {CHATBOT_MODE === 'popup' && (
                        <ChatbotPopup isOpen={isChatbotOpen} onClose={handleChatbotClose} />
                    )}
                    {CHATBOT_MODE === 'sidebar' && (
                        <ChatbotSidebar isOpen={isChatbotOpen} onClose={handleChatbotClose} />
                    )}
                </>
            )}
        </React.Fragment>
    );
};

export default ApplicationContentWrapper;
